import { render, staticRenderFns } from "./component-fcbecf18.vue?vue&type=template&id=0071c74c&scoped=true&"
import script from "./component-fcbecf18.vue?vue&type=script&lang=js&"
export * from "./component-fcbecf18.vue?vue&type=script&lang=js&"
import style0 from "./component-fcbecf18.vue?vue&type=style&index=0&id=0071c74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0071c74c",
  null
  
)

export default component.exports